import sc1 from "./assets/movies/sc1.mp4";
import wyb1 from "./assets/movies/wyb1.mp4";
import sc1nie from "./assets/movies/sc1nie.mp4";
import sc2 from "./assets/movies/sc2.mp4";
import wyb2 from "./assets/movies/wyb2.mp4";
import sc3 from "./assets/movies/sc3.mp4";
import wyb3a from "./assets/movies/wyb3a.mp4";
import sc5_9 from "./assets/movies/sc5.9.mp4";
import wyb4a from "./assets/movies/wyb4a.mp4";
import sc13_21 from "./assets/movies/sc13.21.mp4";
import sc14_21 from "./assets/movies/sc14.21.mp4";
import wyb5a from "./assets/movies/wyb5a.mp4";
import sc25_33_35 from "./assets/movies/sc25.33.35.mp4";
import sc26_34_35 from "./assets/movies/sc26.34.35.mp4";
import wyb6a from "./assets/movies/wyb6a.mp4";
import sc36_39 from "./assets/movies/sc36.39.mp4";
import sc37_41 from "./assets/movies/sc37.41.mp4";
import wyb7 from "./assets/movies/wyb7.mp4";
import sc43 from "./assets/movies/sc43.mp4";
import sc44 from "./assets/movies/sc44.mp4";
import sc6_10 from "./assets/movies/sc6.10.mp4";
import wyb4b from "./assets/movies/wyb4b.mp4";
import sc15_22 from "./assets/movies/sc15.22.mp4";
import sc16_22 from "./assets/movies/sc16.22.mp4";
import wyb5b from "./assets/movies/wyb5b.mp4";
import sc27_33_35 from "./assets/movies/sc27.33.35.mp4";
import sc28_34_35 from "./assets/movies/sc28.34.35.mp4";
import wyb6b from "./assets/movies/wyb6b.mp4";
import sc36_40 from "./assets/movies/sc36.40.mp4";
import sc37_42 from "./assets/movies/sc37.42.mp4";
import sc4 from "./assets/movies/sc4.mp4";
import wyb3b from "./assets/movies/wyb3b.mp4";
import sc7_11 from "./assets/movies/sc7.11.mp4";
import sc8_12 from "./assets/movies/sc8.12.mp4";
import wyb4c from "./assets/movies/wyb4c.mp4";
import sc17_23 from "./assets/movies/sc17.23.mp4";
import sc18_23 from "./assets/movies/sc18.23.mp4";
import wyb5c from "./assets/movies/wyb5c.mp4";
import sc29_33_35 from "./assets/movies/sc29.33.35.mp4";
import sc30_34_35 from "./assets/movies/sc30.34.35.mp4";
import wyb4d from "./assets/movies/wyb4d.mp4";
import sc19_24 from "./assets/movies/sc19.24.mp4";
import sc20_24 from "./assets/movies/sc20.24.mp4";
import wyb5d from "./assets/movies/wyb5d.mp4";
import sc31_33_35 from "./assets/movies/sc31.33.35.mp4";
import sc32_34_35 from "./assets/movies/sc32.34.35.mp4";

const MoviesList = [
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc1',
		video: sc1,
		redirectTo: '/wyb1'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb1',
		video: wyb1,
		leftButton: { label: 'Tak', linkTo: '/sc2' },
		rightButton: { label: 'Nie', linkTo: '/sc1nie' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc1nie',
		video: sc1nie,
		redirectTo: '/wyb1'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc2',
		video: sc2,
		redirectTo: '/wyb2'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb2',
		video: wyb2,
		leftButton: { label: 'Podchodzi do mężczyzny', linkTo: '/sc3' },
		rightButton: { label: 'Stoi i patrzy', linkTo: '/sc4' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc3',
		video: sc3,
		redirectTo: '/wyb3a'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb3a',
		video: wyb3a,
		leftButton: { label: 'Nie znajduje książki', linkTo: '/sc5_9' },
		rightButton: { label: 'Znajduje książkę', linkTo: '/sc6_10' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc5_9',
		video: sc5_9,
		redirectTo: '/wyb4a'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb4a',
		video: wyb4a,
		leftButton: { label: 'Daje za wygraną', linkTo: '/sc13_21' },
		rightButton: { label: 'Nie odpuszcza', linkTo: '/sc14_21' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc13_21',
		video: sc13_21,
		redirectTo: '/wyb5a'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc14_21',
		video: sc14_21,
		redirectTo: '/wyb5a'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb5a',
		video: wyb5a,
		leftButton: { label: 'Tramwajem', linkTo: '/sc25_33_35' },
		rightButton: { label: 'Na piechotę', linkTo: '/sc26_34_35' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc25_33_35',
		video: sc25_33_35,
		redirectTo: '/wyb6a'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc26_34_35',
		video: sc26_34_35,
		redirectTo: '/wyb6a'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb6a',
		video: wyb6a,
		leftButton: { label: 'Decyduje się na UMED', linkTo: '/sc36_39' },
		rightButton: { label: 'Jeszcze nie wie', linkTo: '/sc37_41' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc36_39',
		video: sc36_39,
		redirectTo: '/wyb7'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc37_41',
		video: sc37_41,
		redirectTo: '/wyb7'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb7',
		video: wyb7,
		leftButton: { label: 'Zostają parą', linkTo: '/sc43' },
		rightButton: { label: 'Nie zostają parą', linkTo: '/sc44' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc43',
		video: sc43,
		redirectTo: '/'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc44',
		video: sc44,
		redirectTo: '/'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc6_10',
		video: sc6_10,
		redirectTo: '/wyb4b'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb4b',
		video: wyb4b,
		leftButton: { label: 'Daje za wygraną', linkTo: '/sc15_22' },
		rightButton: { label: 'Nie odpuszcza', linkTo: '/sc16_22' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc15_22',
		video: sc15_22,
		redirectTo: '/wyb5b'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc16_22',
		video: sc16_22,
		redirectTo: '/wyb5b'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb5b',
		video: wyb5b,
		leftButton: { label: 'Tramwajem', linkTo: '/sc27_33_35' },
		rightButton: { label: 'Na piechotę', linkTo: '/sc28_34_35' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc27_33_35',
		video: sc27_33_35,
		redirectTo: '/wyb6b'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc28_34_35',
		video: sc28_34_35,
		redirectTo: '/wyb6b'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb6b',
		video: wyb6b,
		leftButton: { label: 'Decyduje się na UMED', linkTo: '/sc36_40' },
		rightButton: { label: 'Jeszcze nie wie', linkTo: '/sc37_42' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc36_40',
		video: sc36_40,
		redirectTo: '/wyb7'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc37_42',
		video: sc37_42,
		redirectTo: '/wyb7'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc4',
		video: sc4,
		redirectTo: '/wyb3b'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb3b',
		video: wyb3b,
		leftButton: { label: 'Nie znajduje książki', linkTo: '/sc7_11' },
		rightButton: { label: 'Znajduje książkę', linkTo: '/sc8_12' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc7_11',
		video: sc7_11,
		redirectTo: '/wyb4c'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc8_12',
		video: sc8_12,
		redirectTo: '/wyb4d'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb4c',
		video: wyb4c,
		leftButton: { label: 'Daje za wygraną', linkTo: '/sc17_23' },
		rightButton: { label: 'Nie odpuszcza', linkTo: '/sc18_23' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc17_23',
		video: sc17_23,
		redirectTo: '/wyb5c'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc18_23',
		video: sc18_23,
		redirectTo: '/wyb5c'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb5c',
		video: wyb5c,
		leftButton: { label: 'Tramwajem', linkTo: '/sc29_33_35' },
		rightButton: { label: 'Na piechotę', linkTo: '/sc30_34_35' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc29_33_35',
		video: sc29_33_35,
		redirectTo: '/wyb6a'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc30_34_35',
		video: sc30_34_35,
		redirectTo: '/wyb6a'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb4d',
		video: wyb4d,
		leftButton: { label: 'Daje za wygraną', linkTo: '/sc19_24' },
		rightButton: { label: 'Nie odpuszcza', linkTo: '/sc20_24' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc19_24',
		video: sc19_24,
		redirectTo: '/wyb5d'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc20_24',
		video: sc20_24,
		redirectTo: '/wyb5d'
	},
	{
		component: 'MovieWithButtonsView',
		path: '/wyb5d',
		video: wyb5d,
		leftButton: { label: 'Tramwajem', linkTo: '/sc31_33_35' },
		rightButton: { label: 'Na piechotę', linkTo: '/sc32_34_35' }
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc31_33_35',
		video: sc31_33_35,
		redirectTo: '/wyb6b'
	},
	{
		component: 'MovieWithRedirectOnFinishView',
		path: '/sc32_34_35',
		video: sc32_34_35,
		redirectTo: '/wyb6b'
	},
];

export default MoviesList;